import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../utils/firebase";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

export default function SignupPage() {
  // Firebase Auth (shared app instance)
  const googleProvider = new GoogleAuthProvider();

  // 4. React state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [username, setUsername] = useState("");
  const [error, setError] = useState(null);

  // 5. React Router navigation
  const navigate = useNavigate();

  // 6. Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Basic password match check
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      // Create user with email and password
      await createUserWithEmailAndPassword(auth, email, password);
      // Optionally, you can store the username in Firestore or update the profile

      // Navigate to your protected page
      navigate("/");
    } catch (err) {
      setError(err.message || "Failed to create an account.");
    }
  };

  // 7. (Optional) Handle Google signup
  const handleGoogleSignup = async () => {
    setError(null);
    try {
      await signInWithPopup(auth, googleProvider);
      // User is signed in; go to the protected page
      navigate("/");
    } catch (err) {
      setError(err.message || "Google sign-up failed.");
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 text-gray-800">
      <main className="flex-1 flex items-center justify-center px-4 py-6 max-w-[100vw]  mx-auto">
        <div className="w-full max-w-md bg-white rounded-md shadow p-6">
          <h1 className="text-2xl font-bold mb-4">Sign up</h1>

          {/* Display error, if any */}
          {error && <div className="text-red-500 mb-2">{error}</div>}

          {/* SIGNUP FORM */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Username */}
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Username
              </label>
              <input
                type="text"
                id="username"
                placeholder="Choose a username"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                placeholder="Create a password"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label
                htmlFor="confirm-password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Confirm Password
              </label>
              <input
                type="password"
                id="confirm-password"
                placeholder="Confirm your password"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>

            {/* Submit button */}
            <button
              type="submit"
              className="w-full bg-blue-600 text-white text-sm font-semibold py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              Sign up
            </button>
          </form>

          {/* Google sign up (optional) */}
          <button
            onClick={handleGoogleSignup}
            className="mt-4 w-full bg-red-600 text-white text-sm font-semibold py-2 rounded-md hover:bg-red-700 transition-colors"
          >
            Sign up with Google
          </button>

          {/* Extra links */}
          <div className="mt-4 text-sm text-center">
            Already have an account?{" "}
            <a
              href="/login"
              className="text-blue-600 font-medium hover:underline"
            >
              Log in
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
